(function () {
    'use strict';
    /*
     * Copyright (c) 2016 In Hand Health.
     * All rights reserved.
     */

    /**
     * @ngdoc directive
     * @name ihh-common-web.prescription-content-edit
     * @restrict E
     * @scope
     *
     * @param {object} prescription the prescription exercise objects
     * @param {String} prescriptionKey the key to access the prescription exercises by property name
     * @param {object} prescriptionForm the prescription form object
     *
     * @description
     *  This directive is used to create the prescription content edit
     *  page and is necessary for edit functionality.
     *
     * @example
     * <prescription-content-edit
     *  prescription="prescriptionTemplates"
     *  prescription-key="exerciseTemplates"
     *  prescription-form="protocolForm">
     * </prescription-content-edit>
     */
    angular
        .module('ihh-common-web')
        .directive('prescriptionContentEdit', prescriptionContentEdit);

    prescriptionContentEdit.$inject = ['RxExUtilities', 'ResearchUtilities', 'IhhArrays', 'Utilities'];

    function prescriptionContentEdit(RxExUtilities, ResearchUtilities, IhhArrays, Utilities) {
        return {
            restrict: 'E',
            scope: {
                prescription: '=',
                prescriptionKey: '@',
                prescriptionForm: '=',
                sortListeners: '='
            },
            templateUrl: 'prescription-content/prescription-content-edit.tpl.html',
            link: function(scope) {
                // This guards against the prescription coming in with a null (not empty) array of prescription exercises
                scope.prescription[scope.prescriptionKey] = scope.prescription[scope.prescriptionKey] || [];
                scope.exerciseTemplates = scope.prescription[scope.prescriptionKey];
                scope.displayQuantityType = ResearchUtilities.displayQuantityType;
                scope.quantityTypes = RxExUtilities.getQuantityTypes();

                scope.getValueString = function (value) {
                    if (value === 'Repetitions') {
                        return 'Reps';
                    }
                    return value;
                };

                scope.getResistanceItemValue = function (exerciseTemplate) {
                    return RxExUtilities.getResistanceItemValue(exerciseTemplate);
                };

                scope.getQuantityType = function (exerciseTemplate) {
                    return RxExUtilities.getQuantityType(exerciseTemplate);
                };

                scope.getExerciseLinkUrl = function (exerciseTemplate) {
                    return RxExUtilities.getExerciseLinkUrl(exerciseTemplate, true);
                };

                scope.getExerciseThumbnailUrl = function (exerciseTemplate) {
                    return RxExUtilities.getExerciseThumbnailUrl(exerciseTemplate.exercise, false);
                };

                scope.setQuantityType = function (quantityType, exerciseTemplate, form) {
                    RxExUtilities.setQuantityType(quantityType, exerciseTemplate, form);
                };

                scope.selectQuantityType = function (quantityType, exerciseTemplate, form, $event) {
                    RxExUtilities.setQuantityType(quantityType, exerciseTemplate, form);

                    $event.target.parentElement.parentElement.parentElement.click();
                };

                scope.setResistanceItemValue = function (state, exerciseTemplate, form) {
                    RxExUtilities.setResistanceItemValue(state, exerciseTemplate, form);
                };

                scope.deleteExerciseTemplate = function (form, exerciseTemplate) {
                    var exerciseTemplateIndex;

                    if (Utilities.isDefinedAndNotNull(exerciseTemplate.id)) {
                        exerciseTemplateIndex = IhhArrays.indexOfById(scope.exerciseTemplates, exerciseTemplate.id);
                    }
                    else {
                        // look for the temp id
                        exerciseTemplateIndex = IhhArrays.indexOfByTempId(scope.exerciseTemplates, exerciseTemplate._id);
                    }

                    if (exerciseTemplateIndex >= 0) {
                        scope.exerciseTemplates.splice(exerciseTemplateIndex, 1);
                        form.$setDirty();
                    }
                };

                scope.isEmptyDropzone = function() {
                    return !scope.exerciseTemplates || scope.exerciseTemplates.length === 0;
                };

                /**
                 * Returns whether the metronome value is considered available, either at the template or
                 * exercise, for the purpose of editing.
                 * @param {type} exerciseTemplate the template
                 * @returns {Boolean} true if the metronome is set (even to zero)
                 */
                scope.isMetronome = function (exerciseTemplate) {
                    if (!exerciseTemplate) {
                        return false;
                    }

                    return (exerciseTemplate.metronome && exerciseTemplate.metronome >= 0)
                            || (exerciseTemplate.exercise && exerciseTemplate.exercise.metronome && exerciseTemplate.exercise.metronome >= 0);
                };
            }
        };
    }
})();